import {
  SET_DEPARTURE, SET_TOURID, SET_PROMO_CODE,SET_CITYID, SET_PROCESSING, SET_BOOKING, SET_PASSENGER_TYPE, SET_PRICES,
  RESET_BOOKING, SET_PASSENGER_DETAILS, SET_CURRENCY, SET_BOOKING_GROUP, FETCH_TOUR, BOOK_TOUR_FAIL, SET_LOCKOUT,
  SET_TRIPS_PASSENGERS,
  UPDATE_TOUR_INFORMATION_LOADING, UPDATE_TOUR_INFORMATION, UPDATE_TOUR_INFORMATION_FAIL, DELETE_TOUR_INFORMATION, DELETE_TOUR_INFORMATION_FAIL, ADD_TOUR_INFORMATION, ADD_TOUR_INFORMATION_FAIL,
  ADD_TRIPS, SET_TOUR_NAME_OVERRIDE,
  POST_ITINERARIES, POST_ITINERARIES_FAIL, POST_ITINERARIES_LOADING
} from '../actions/types';
import update from 'immutability-helper';

const leadPaxIndex = 0;
const currentBookingIndex = 0;
const currentBookingState = {
  "booking_confirmation": {
    "hold_info": {
        "days": (process.env.REACT_APP_ENV === "production") ? process.env.REACT_APP_HOLD_INFO_DAYS_EXPIRE : 7,
        "hours": (process.env.REACT_APP_ENV === "production") ? process.env.REACT_APP_HOLD_INFO_HOURS_EXPIRE : 0,
        "minutes": (process.env.REACT_APP_ENV === "production") ? process.env.REACT_APP_HOLD_INFO_MINUTES_EXPIRE : 0,
        "seconds": (process.env.REACT_APP_ENV === "production") ? process.env.REACT_APP_HOLD_INFO_SECONDS_EXPIRE : 0,
    },
  },
  "booking_information": {
    "iso_currency_code":"",
    "payments": []
  },
  "trips":[{
    "tour_id": "",
    "tour_name_override":"",
    "city_id": "0",
    "departure_date": "",
    "promo_code": "",
    "passengers": [],
    "add_ons": []
  }],
  "passengers":[],
  "processing":false,
  "booking":false,
  "lockout":false,
  "prices":{}
}



export function CurrentBooking(state = currentBookingState, action){

  switch (action.type) {

    case SET_CURRENCY:
      return update(state,{booking_information:{iso_currency_code:{$set:action.payload.data.currency_info.iso_currency_code}}});

    case SET_TOURID:
      return update(state, {trips:{[currentBookingIndex]:{ tour_id:{$set:action.payload.tourID}}}});

    case SET_TOUR_NAME_OVERRIDE:
      return update(state, {trips:{[currentBookingIndex]:{ tour_name_override:{$set:action.payload}}}});

    case SET_DEPARTURE:
      return update(state, {trips:{[currentBookingIndex]:{ departure_date:{$set:action.payload.date}}}});

    case SET_PROMO_CODE:
      return update(state, {trips:{[currentBookingIndex]:{ promo_code:{$set:action.payload.promoCode}}}});

    case SET_TRIPS_PASSENGERS:
      return update(state, {trips:{[currentBookingIndex]:{ passengers:{$set:action.payload}}}});

    case SET_CITYID:
      return update(state, {trips:{[currentBookingIndex]:{ city_id:{$set:action.payload.cityID}}}});

    case SET_PASSENGER_TYPE:
      return update(state, {passengers:{$set:action.payload.paxArray}});


    case SET_PASSENGER_DETAILS:

        return update(state, { passengers:{[leadPaxIndex]:{
            first_name:{$set:action.payload.firstName},
            family_name:{$set:action.payload.surname},
            email:{$set:action.payload.email},
            contact_telephone_country:{$set:action.payload.phonePrefix},
            contact_telephone_number:{$set:action.payload.phone}
          }}});

    case SET_PROCESSING:
      return update(state, {processing:{$set:action.payload}});

    case SET_BOOKING:
      return update(state, {booking:{$set:action.payload}});

    case SET_LOCKOUT:
      return update(state, {lockout:{$set:action.payload}});

    case SET_PRICES:
      return update(state, {prices:{$set:action.payload.prices}});

    case ADD_TRIPS:
      return update(state, {trips: {$push:action.payload}});

    case RESET_BOOKING:
      return update(state, {
        trips: {
          [currentBookingIndex]: {
            "tour_id": { $set: "" },
            "city_id": { $set: "0"},
            "departure_date": { $set: ""},
            "promo_code": { $set: "" },
            "passengers": { $set: [] },
            "add_ons": { $set: []}
          }
        }
      });
    default:
      return state;
  }
}


const bookingGroupInitialState = {
  data:{},
  isValid:true,
  updating:false
}

export function BookingGroup(state = bookingGroupInitialState, action){
  switch (action.type) {
    case FETCH_TOUR:
    case SET_BOOKING_GROUP:
      return update(state, {data:{$set:action.payload}});

    case BOOK_TOUR_FAIL:
        return update(state, {isValid:{$set:action.payload}});

    case ADD_TOUR_INFORMATION:
    case ADD_TOUR_INFORMATION_FAIL:
    case DELETE_TOUR_INFORMATION:
    case DELETE_TOUR_INFORMATION_FAIL:
    case UPDATE_TOUR_INFORMATION_LOADING:
    case UPDATE_TOUR_INFORMATION:
    case UPDATE_TOUR_INFORMATION_FAIL:
    case POST_ITINERARIES:
    case POST_ITINERARIES_FAIL:
    case POST_ITINERARIES_LOADING:
      return update(state, {updating:{$set:action.payload}});

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_booking.js